module.exports = __webpack_public_path__ + "media/site/fonts/TheNorthernBlockLtd-NeoGram-Bold-804b7be945b80afbe3987f6a6040878e.otf";